import { render } from "./accessControl.vue?vue&type=template&id=6024cdd7&scoped=true"
import script from "./accessControl.vue?vue&type=script&lang=js"
export * from "./accessControl.vue?vue&type=script&lang=js"

import "./accessControl.vue?vue&type=style&index=0&id=6024cdd7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6024cdd7"]])

export default __exports__